import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { debounceTime } from 'rxjs';
import {
  FileDragDropComponent,
  IconDirective,
  InputDirective,
  PopoverRef,
  SpinnerComponent,
  TooltipDirective,
  ButtonDirective,
  ReferenceCardComponent,
} from 'shared/ui-common';

import { POPOVER_DATA, Reference, ReferencePopoverData } from '@treetop/shared/model';

import { ReferencePopoverStore } from './reference-popover.state';

@Component({
  selector: 'tt-reference-popover',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReferenceCardComponent,
    IconDirective,
    MatIconModule,
    TranslocoPipe,
    ReactiveFormsModule,

    TooltipDirective,
    FileDragDropComponent,
    SpinnerComponent,
    InputDirective,
    ButtonDirective,
  ],
  templateUrl: './reference-popover.component.html',
  styleUrl: './reference-popover.component.scss',
  providers: [ReferencePopoverStore],
})
export class ReferencePopoverComponent {
  protected referenceData = inject<ReferencePopoverData>(POPOVER_DATA, { optional: true });
  private popoverRef = inject(PopoverRef, { optional: true });
  protected readonly store = inject(ReferencePopoverStore);

  public referencesAdded = output<Reference[]>();

  protected readonly viewModel = this.store.vm;

  protected extractOrSearchFormControl = new FormControl('', { nonNullable: true });

  constructor() {
    this.store.init({
      disabled: this.referenceData?.disabled ?? [],
      selected: this.referenceData?.selected ?? [],
      disableExisting: this.referenceData?.disableExisting,
    });

    this.extractOrSearchFormControl.valueChanges.pipe(debounceTime(300)).subscribe((value) => {
      this.store.extractOrSearch(value);
    });
  }

  protected handleFileChanged($event: File) {
    this.store.updateFile($event);
  }

  protected addReferences(references: Reference[]) {
    this.referencesAdded.emit(references);
    this.popoverRef?.close(references);
  }
}
